import React from 'react'

export const SendMessageIcon = ({ fill = '#306FD1' }) => (
  <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M29.7123 11.0863C31.5612 10.5552 33.2669 12.2609 32.7358 14.1098L28.0422 30.4486C27.2598 33.1721 23.6227 33.6896 22.1285 31.29L20.0567 27.9631C19.4836 27.043 19.6224 25.8469 20.3914 25.078L24.8135 20.6558C25.2698 20.1994 25.2711 19.4608 24.8162 19.006C24.3615 18.5512 23.6228 18.5524 23.1664 19.0088L18.7444 23.4309C17.9754 24.1998 16.7794 24.3386 15.8592 23.7656L12.5321 21.6937C10.1325 20.1994 10.65 16.5623 13.3735 15.78L29.7123 11.0863Z" fill={fill} />
  </svg>
)
